import { UserState } from "@/auth/user"
import { SUPER_COFFEE_ORG_SID } from "@/deduction_table/util"

/**
 * Custom hook to check if the current user is from Super Coffee
 * @returns boolean indicating if the user is from Super Coffee
 */
export function useSuperCoffee(): boolean {
  const userState = UserState.use()
  return userState?.org_id === SUPER_COFFEE_ORG_SID
}

/**
 * Custom hook to check if redistribution should be shown for Super Coffee users
 * @param hasUncodedOrMisc - boolean indicating if the data contains "Uncoded" or "Misc" items
 * @returns boolean indicating if redistribution button should be shown
 */
export function useShowRedistribution(hasUncodedOrMisc: boolean): boolean {
  const isSuperCoffee = useSuperCoffee()
  return isSuperCoffee && hasUncodedOrMisc
} 